import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function Valuescard (props) {
    const theme = useSelector((state) => state.themedata.theme)

    const [valuefont, setValuefont] = useState(20)
    const [timefont, setTimefont] = useState(14)
    const [valuefonttype, setValuefonttype] = useState("Roboto")
    const [timefonttype, setTimefonttype] = useState("Roboto")
    const [timecolor, setTimecolor] = useState("#000000")
    const [tagpropsarray, setTagpropsarray] = useState([])
    const [discfontsize, setDiscfontsizs] = useState(16)
    const [discfonttype, setDiscfonttype] = useState("Roboto")
    const [Orientation, setOrientation] = useState("Horizontal")
    const [gap, setGap] = useState(20)
    const [boderradius, setBorderradius] = useState(0)

    useEffect(() => {
        //console.log("value card ", props.extendedprops)
        if(props.extendedprops !== undefined) {
            if(props.extendedprops.hasOwnProperty("font")) {
                setValuefont(props.extendedprops.font.valuefontsize)
                setTimefont(props.extendedprops.font.timefontsize)
                setValuefonttype(props.extendedprops.font.valuefonttype)
                setTimefonttype(props.extendedprops.font.timefonttype)
                setDiscfontsizs(props.extendedprops.font.discriptionfontsize)
                setDiscfonttype(props.extendedprops.font.discriptionfonttype)
                setOrientation(props.extendedprops.orientation)
                setGap(props.extendedprops.gap)
                setBorderradius(props.extendedprops.borderradius)
                if(theme === 'dark') {
                    setTimecolor(props.extendedprops.color.dark.timecolor)
                } else {
                    setTimecolor(props.extendedprops.color.light.timecolor)
                }
                //console.log("val card ",props.extendedprops.tagpropslist)
                setTagpropsarray(props.extendedprops.tagpropslist)
            }
        }
    },[props.extendedprops])

    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{display: 'flex', height: '88%', width: '95%', alignItems: 'center', justifyContent: 'center'}}>
                { Orientation === "Horizontal" && 
                    <div style={{display: 'flex', width: '100%', flexDirection: 'column', gap: gap+'px'}}>
                        {
                            tagpropsarray.map((tagprops) => {
                                return(
                                    <div style={{display: 'flex', flexDirection: 'row', width: '96%', borderRadius: boderradius+'px', backgroundColor: tagprops.backgroundcolor, padding: '10px',alignItems: 'center', justifyContent: 'center'}}>
                                        <Typography style={{fontSize: discfontsize+"px", fontFamily: discfonttype, color: tagprops.textcolor, fontWeight: 400}}> {tagprops.datapointname} </Typography>
                                        <div style={{flexGrow: 1}}></div>
                                        <Typography style={{fontSize: valuefont+"px", fontFamily: valuefonttype, color: tagprops.textcolor, fontWeight: 500}}> 0 </Typography>
                                    </div>
                                )
                            })
                        }
                    </div> 
                }
                { Orientation === "Vertical" &&    
                    <div style={{display: 'flex', width: '100%', flexDirection: 'row', gap: gap+'px', alignItems: 'center', justifyContent: 'center'}}>
                        {
                            tagpropsarray.map((tagprops) => {
                                return(
                                    <div style={{display: 'flex', flexDirection: 'column', borderRadius: boderradius+'px', backgroundColor: tagprops.backgroundcolor, padding: '10px',alignItems: 'center', justifyContent: 'center'}}>
                                        <Typography style={{fontSize: discfontsize+"px", fontFamily: discfonttype, color: tagprops.textcolor, fontWeight: 400}}> {tagprops.datapointname} </Typography>
                                        <div style={{flexGrow: 1}}></div>
                                        <Typography style={{fontSize: valuefont+"px", fontFamily: valuefonttype, color: tagprops.textcolor, fontWeight: 500}}> 0 </Typography>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
            <div style={{display: 'flex', alignItems:'center', justifyContent: 'center'}}>
                <Typography style={{fontSize: timefont+"px", fontFamily: timefonttype, color: timecolor}}> 01-01-1970 00:00:00 </Typography>
            </div>
            
        </div>
    )
}